// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__2GIVV","body":"header_body__Ibhhp"};